import React, { useContext, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import AvatarPicture from 'components/assistant/AvatarPicture';
import InputList from 'components/common/InputList';
import { useFetchData } from 'hooks/apiHooks';
import { API_ENDPOINTS } from 'constants';
import ApiError from 'components/common/ApiError';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { useLanguageOptions } from 'hooks/useLanguageOptions';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { useContact } from 'hooks/useContact';

function UserContact({contactId}) {
    const { languageOptions } = useLanguageOptions()
    const {data, saveKey, isLoading, error, saveError, success, refetch} = useFetchData(API_ENDPOINTS.CUSTOMERS.ITEM(contactId))

    const items = [
        { label: 'users.label.first_name', icon: 'label', key: 'firstname', type: 'text' },
        { label: 'users.label.middle_names', icon: 'label', key: 'middle_names', type: 'text'},
        { label: 'users.label.last_name', icon: 'label', key: 'lastname', type: 'text'},
        { label: 'users.label.email', icon: 'email', key: 'email', type: 'email' },
        { label: 'users.label.phone', icon: 'phone', key: 'phone', type: 'text' },
        { label: 'users.label.language', icon: 'globe', key: 'language', type: "elementSelect", options: languageOptions },
        { label: 'users.label.birthday', icon: 'birthday', key: 'birthday', type: "date" },
    ];

    if (isLoading) return <Skeleton height={30} count={20} />;
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>

    return (
        <>
            <InputList fields={items} data={data} onChange={saveKey}/>
        </>
    );
}

function UserProfile() {
    const { t } = useTranslation();
    const { userId } = useContext(UserSettingsContext);
    const { createContact } = useContact()
    const {data, saveKey, isLoading, error, refetch} = useFetchData(API_ENDPOINTS.USERS.TENANT_USER(userId?.tenant_user_id))
    console.log(data)

    const { getAccessTokenSilently, user, isLoading: isAuth0Loading } = useAuth0();

    const createContactFromAuth0 = async () => {
        console.log(data)
        if(!data)return
        const newContactId = await createContact({
            id: -1,
            firstname: user?.given_name,
            lastname: user?.family_name,
            //email: user?.email,
            phone: user?.phone,
            picture: user?.picture,
            originalPicture: user?.picture
        })
        saveKey('contact_id', newContactId)
    }

    useEffect(() => {
        if (!userId.contact_id) {
            createContactFromAuth0()
        }
    }, [userId.contact_id]);

    if (isAuth0Loading) return <Skeleton height={30} count={20} />;
    if (isLoading) return <Skeleton height={30} count={20} />;
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>

    console.log(userId)

    const roleName = userId?.tenant_role || t('userProfile.noRole');

    return (
        <Card className="card-user">
            <CardBody>
                <AvatarPicture picture={user?.picture} title={t("userProfile.title", {role: roleName})}/>
                { data.contact_id ?
                    <UserContact contactId={data.contact_id}/>
                :
                    <IconButtonWithTooltip translationId='Kontakt anlegen' icon={faMagicWandSparkles} onClick={()=>{createContactFromAuth0()}} type="Button"/>
                }
            </CardBody>
        </Card>
    );
}

export default UserProfile;


/*
                {(isAuth0Loading) ? <Skeleton count="4" height={40}/> : (
                    <>
                        <IconInput label="First Name" iconKey="avatarName" value={userData.given_name} onChange={(e) => handleChange("given_name", e.target.value)}/>
                        <IconInput label="Last Name" iconKey="avatarName" value={userData.family_name} onChange={(e) => handleChange("family_name", e.target.value)}/>
                        <IconInput label="Email" iconKey="email" value={userData.email} onChange={(e) => handleChange("email", e.target.value)}/>
                        <IconInput label="Phone" iconKey="phone" value={userData.phone_number} onChange={(e) => handleChange("phone_number", e.target.value)}/>
                    </>
                )}
*/